import { createFileRoute } from "@tanstack/react-router";

import EmailHistoryPage from "@/admin/email-history/page";

export const Route = createFileRoute("/app/$storeId/email-history")({
    component: RouteComponent,
});

function RouteComponent() {
    return <EmailHistoryPage />;
}
